<template>
  <div>
    <section class="content-header">
      <h1>Packages</h1>
    </section>

    <section class="content">
      <div class="row">
        <div v-for="(item, index) in tableData" :key="index" class="col-md-4 col-xl-4 col-sm-6 col-xs-12">
          <div class="cyber-plan" :class="{ 'cyber-plan--upgrade': isUpgrade(item.price) }">
            <div class="cyber-plan__glow"></div>
            <div class="cyber-plan__badge-wrap">
              <img :src="'/images/icons/' + item.code + '.png'" alt class="cyber-plan__badge" />
            </div>
            <div class="cyber-plan__body">
              <h4 class="cyber-plan__name">{{ item.name }}</h4>

              <div class="cyber-plan__price">
                <span class="cyber-plan__price-symbol">$</span>
                <span class="cyber-plan__price-value">{{ item.price }}</span>
                <span class="cyber-plan__price-unit">USD</span>
              </div>
              <p class="cyber-plan__period">One Time Payment</p>

              <div class="cyber-plan__divider"></div>

              <template v-if="item.description.split('//').length > 0">
                <ul class="cyber-plan__features">
                  <li v-for="x in item.description.split('//')" :key="x">
                    <i class="mdi mdi-check-circle-outline"></i>
                    <span>{{ x }}</span>
                  </li>
                </ul>
              </template>

              <button
                v-if="!loading"
                class="btn btn-block cyber-plan__btn"
                :class="isUpgrade(item.price) ? 'btn-success' : 'btn-dark'"
                @click.prevent="createInvoice(item.code, isUpgrade(item.price))"
              >
                <template v-if="isUpgrade(item.price)">
                  <span>UPGRADE NOW</span>
                  <i class="mdi mdi-rocket ml-2"></i>
                </template>
                <template v-else>
                  <span>BUY NOW</span>
                  <i class="mdi mdi-flash-outline ml-2"></i>
                </template>
              </button>
              <button v-else class="btn btn-block btn-dark" disabled>
                Loading <i class="fa fa-spinner fa-spin"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
    <invoice-payment></invoice-payment>
  </div>
</template>

<style scoped>
.cyber-plan {
  background: linear-gradient(135deg, #252525, #2e2e2e);
  border: 1px solid #3d3d37;
  border-radius: 16px;
  margin-top: 50px;
  margin-bottom: 20px;
  overflow: visible;
  position: relative;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  text-align: center;
}

.cyber-plan:hover {
  border-color: rgba(176, 154, 78, 0.3);
  transform: translateY(-6px);
  box-shadow: 0 15px 45px rgba(0, 0, 0, 0.4), 0 0 25px rgba(176, 154, 78, 0.1);
}

.cyber-plan--upgrade {
  border-color: rgba(176, 154, 78, 0.2);
}

.cyber-plan--upgrade:hover {
  border-color: rgba(176, 154, 78, 0.5);
  box-shadow: 0 15px 45px rgba(0, 0, 0, 0.4), 0 0 35px rgba(176, 154, 78, 0.15);
}

.cyber-plan__glow {
  height: 2px;
  background: linear-gradient(90deg, transparent, #B09A4E, #7BBFB5, transparent);
  border-radius: 16px 16px 0 0;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.cyber-plan:hover .cyber-plan__glow {
  opacity: 1;
}

.cyber-plan--upgrade .cyber-plan__glow {
  opacity: 1;
  background: linear-gradient(90deg, transparent, #B09A4E, #CDBA6E, #B09A4E, transparent);
}

.cyber-plan__badge-wrap {
  position: absolute;
  top: -40px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 2;
}

.cyber-plan__badge {
  width: 80px;
  height: 80px;
  object-fit: contain;
  filter: drop-shadow(0 0 15px rgba(176, 154, 78, 0.4));
  transition: all 0.3s ease;
}

.cyber-plan:hover .cyber-plan__badge {
  filter: drop-shadow(0 0 25px rgba(176, 154, 78, 0.6));
  transform: scale(1.05);
}

.cyber-plan__body {
  padding: 50px 25px 25px;
}

.cyber-plan__name {
  font-family: 'Orbitron', sans-serif !important;
  font-size: 0.9rem !important;
  color: #B09A4E !important;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  margin-bottom: 15px !important;
  text-shadow: 0 0 10px rgba(176, 154, 78, 0.2);
}

.cyber-plan__price {
  margin-bottom: 5px;
}

.cyber-plan__price-symbol {
  font-family: 'Orbitron', sans-serif;
  font-size: 1rem;
  color: #B09A4E;
  vertical-align: top;
}

.cyber-plan__price-value {
  font-family: 'Orbitron', sans-serif;
  font-size: 2.2rem;
  font-weight: 800;
  color: #E0DFD8;
  line-height: 1;
}

.cyber-plan__price-unit {
  font-family: 'Rajdhani', sans-serif;
  font-size: 0.8rem;
  color: #9A998F;
  margin-left: 4px;
}

.cyber-plan__period {
  font-size: 0.75rem;
  color: #6B6A62;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  margin-bottom: 15px;
}

.cyber-plan__divider {
  height: 1px;
  background: linear-gradient(90deg, transparent, #3d3d37, transparent);
  margin: 15px 0;
}

.cyber-plan__features {
  list-style: none;
  padding: 0;
  margin: 0 0 20px;
  text-align: left;
}

.cyber-plan__features li {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 6px 0;
  font-size: 0.85rem;
  color: #C2C1B8;
}

.cyber-plan__features li i {
  color: #B09A4E;
  font-size: 0.9rem;
  margin-top: 2px;
  flex-shrink: 0;
}

.cyber-plan__btn {
  display: flex !important;
  align-items: center;
  justify-content: center;
  padding: 12px !important;
}
</style>

<script>
import Vue from "vue";
import VueQrcode from "@chenfengyuan/vue-qrcode";

import { serverBus } from "@/main";
import InvoicePayment from "@/components/InvoicePayment";

Vue.component(VueQrcode.name, VueQrcode);

export default {
  data() {
    return {
      loading: false,
      modal: false,
      tableData: []
    };
  },
  components: {
    InvoicePayment
  },
  created() {
    this.getData();
    this.last_subs = this.$store.getters.currentUser.last_subs;
  },
  methods: {
    isUpgrade(planPrice) {
      let result =
        this.$store.getters.currentUser.last_subs &&
        this.$store.getters.currentUser.last_subs.subscription_status ===
        "active" &&
        Number(this.$store.getters.currentUser.last_subs.plan.price) <
        Number(planPrice);
      return result;
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    onCopy() {
      this.$toasted.show("Copied to clipboard!", {
        position: "top-right",
        duration: 5000,
        type: "success",
        closeOnSwipe: true
      });
    },
    createInvoice(code, is_upgrade = false) {
      serverBus.$emit("invoicePaymentModal", {
        code: code,
        is_upgrade: is_upgrade
      });
    },
    getData() {
      this.loading = true;
      this.$http
        .get("/api/v1/client/plans", {
          headers: {
            "content-type": "application/json",
            Authorization: this.$store.getters.authToken
          }
        })
        .then((response) => {
          this.loading = false;
          this.tableData = response.data;
        })
        .catch((error) => {
          error.response.data &&
            error.response.data.map((m) => {
              this.$toasted.show(m, {
                position: "top-right",
                duration: 5000,
                type: "error",
                closeOnSwipe: true
              });
            });
          this.loading = false;
        });
    },
    close() {
      this.modal = false;
    }
  }
};
</script>
